<template>
    <div>
        <div class="page-top mb-1 mb-3">
            <h1> Edit Company </h1>
        </div>
        <div class="global-main">
            <form @submit.prevent="editCompanyData">
                <div class="tab-content-inner">
                    <div class="form-group">
                        <label>Payment Engine</label>
                        <select v-model="form.payment_engine" name="payment_engine" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('payment_engine') }">
                            <option value="" selected>Select Payment Engine</option>
                            <option value="MEEZAN">Meezan Bank</option>
                            <option value="FINCA">Finca Microfinance Bank</option>
                        </select>
                        <has-error :form="form" field="payment_engine"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Name <em class="required">*</em></label>
                        <input v-model="form.name" type="text" name="name" class="form-control" :class="{ 'is-invalid': form.errors.has('name') }">
                        <has-error :form="form" field="name"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Email <em class="required">*</em></label>
                        <input v-model="form.email" type="email" name="email" class="form-control" :class="{ 'is-invalid': form.errors.has('email') }">
                        <has-error :form="form" field="email"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Phone <em class="required">*</em></label>
                        <input v-model="form.phone" type="number" name="phone" class="form-control" :class="{ 'is-invalid': form.errors.has('phone') }">
                        <has-error :form="form" field="phone"></has-error>
                    </div>
                    <div class="form-group">
                        <label> WalletID <em class="required">*</em></label>
                        <input v-model="form.walletID" type="number" name="walletID" class="form-control" :class="{ 'is-invalid': form.errors.has('walletID') }">
                        <has-error :form="form" field="walletID"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Fax </label>
                        <input v-model="form.fax" type="text" name="fax" class="form-control" :class="{ 'is-invalid': form.errors.has('fax') }">
                        <has-error :form="form" field="fax"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Address 1 <em class="required">*</em></label>
                        <textarea v-model="form.address_1" name="address_1" class="form-control" :class="{ 'is-invalid': form.errors.has('address_1') }"></textarea>
                        <has-error :form="form" field="address_1"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Address 2 </label>
                        <textarea v-model="form.address_2" name="address_2" class="form-control" :class="{ 'is-invalid': form.errors.has('address_2') }"></textarea>
                        <has-error :form="form" field="address_2"></has-error>
                    </div>
                    <div class="form-group">
                        <label> City </label>
                        <select v-model="form.city_id" name="city_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('city_id') }" v-if="cities != null">
                            <option value="" selected>Select City</option>
                            <option v-for="city in cities" v-bind:value="city.id" v-bind:key="city.id">
                                {{ city.name }}
                            </option>
                        </select>
                        <has-error :form="form" field="city_id"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Postal Code <em class="required">*</em></label>
                        <input v-model="form.postal_code" type="text" name="postal_code" class="form-control" :class="{ 'is-invalid': form.errors.has('postal_code') }">
                        <has-error :form="form" field="postal_code"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Website </label>
                        <input v-model="form.website" type="text" name="website" class="form-control" :class="{ 'is-invalid': form.errors.has('website') }">
                        <has-error :form="form" field="website"></has-error>
                    </div>

                    <h3>POC Details</h3>
                    <br>
                    <div class="form-group">
                        <label> POC </label>
                        <select v-model="form.poc_id" name="poc_id" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('poc_id') }" v-if="pocs != null">
                            <option value="" selected>Select POC</option>
                            <option v-for="poc in pocs" v-bind:value="poc.id" v-bind:key="poc.id">
                                {{ poc.name }}
                            </option>
                        </select>
                        <has-error :form="form" field="poc_id"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Company Size <em class="required">*</em></label>
                        <input v-model="form.company_size" type="text" name="company_size" class="form-control" :class="{ 'is-invalid': form.errors.has('company_size') }">
                        <has-error :form="form" field="company_size"></has-error>
                    </div>
                    <div class="form-group">
                        <label> Monthly Throughput <em class="required">*</em></label>
                        <input v-model="form.monthly_throughput" type="text" name="monthly_throughput" class="form-control" :class="{ 'is-invalid': form.errors.has('monthly_throughput') }">
                        <has-error :form="form" field="monthly_throughput"></has-error>
                    </div>
                    <div class="form-group">
                        <label> On Board </label>
                        <select v-model="form.on_board" name="on_board" class="selectpicker custom-select2">
                            <option value="" selected>Select Source</option>
                            <option value="FINJA">Finja Pvt LTD</option>
                            <option value="FINCA">Finca Microfinance Bank</option>
                        </select>
                        <has-error :form="form" field="on_board"></has-error>
                    </div>
                    <div class="form-group">
                        <label> On Board Date </label>
                        <datepicker name="on_board_date" v-model="form.on_board_date" input-class="form-control" :class="{ 'is-invalid': form.errors.has('on_board_date') }"></datepicker>
                        <has-error :form="form" field="on_board_date"></has-error>
                    </div>
                    <h3> Store Options </h3>
                    <br>
                    <div class="form-group">
                        <label> Store Permission </label>
                        <select v-model="form.finjaStore" name="finjaStore" class="selectpicker custom-select2" :class="{ 'is-invalid': form.errors.has('finjaStore') }">
                            <option value="SET_NOW" selected>Store Permission</option>
                            <option value="ENABLED">ENABLED</option>
                            <option value="DISABLED">DISABLED</option>
                        </select>
                        <has-error :form="form" field="finjaStore"></has-error>
                    </div>
                </div>
                <div class="form-group">
                    <button :disabled="form.busy" class="btn btn-primary float-right active">Save</button>
                    <router-link to="/companies" class="btn btn-primary float-right mr-2">Cancel</router-link>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                form: new Form({
                    payment_engine : '',
                    name : '',
                    email : '',
                    phone : '',
                    walletID : '',
                    fax : '',
                    address_1 : '',
                    address_2 : '',
                    city_id : '',
                    postal_code : '',
                    website : '',
                    poc_id : '',
                    company_size : '',
                    monthly_throughput : '',
                    on_board : '',
                    on_board_date : new Date(),
                    finjaStore : '',
                }),
                cities: null,
                pocs: null,
                isShow: false,
            }
        },
        methods: {
            editCompanyData() {
                this.$Progress.start();
                this.form.put('/api/updateCompany')
                .then(res => {
                    if(res.status == 200){
                        this.$Progress.finish();
                        toast.fire({
                            type: 'success',
                            title: 'Company updated successfully'
                        });
                        this.$router.push('/companies');
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Some problem in your form data'
                        });
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$Progress.fail();
                    swal.fire({
                        type: 'error',
                        title: 'Some problem in your form data'
                    });
                });
            },
        },
        created() {
            this.$Progress.start();
            axios.get('/api/editCompany/'+this.$route.params.id)
                .then(res => {
                    if(res.status == 200){
                        this.form.id = res.data.id;
                        this.form.payment_engine = res.data.payment_engine;
                        this.form.name = res.data.name;
                        this.form.email = res.data.email;
                        this.form.phone = res.data.phone;
                        this.form.walletID = res.data.walletID;
                        this.form.fax = res.data.fax;
                        this.form.address_1 = res.data.address_1;
                        this.form.address_2 = res.data.address_2;
                        this.form.city_id = res.data.city_id;
                        this.form.town = res.data.town;
                        this.form.postal_code = res.data.postal_code;
                        this.form.website = res.data.website;
                        this.form.facebook = res.data.facebook;
                        this.form.poc_id = res.data.poc_id;
                        this.form.company_size = res.data.company_size;
                        this.form.monthly_throughput = res.data.monthly_throughput;
                        this.form.on_board = res.data.on_board;
                        this.form.on_board_date = res.data.on_board_date;
                        this.form.loan_percentage = res.data.loan_percentage;
                        this.form.loan_service_charges = res.data.loan_service_charges;
                        this.form.loan_month = res.data.loan_month;
                        this.form.finjaStore = res.data.finjaStore;
                        this.pocs = res.data.pocData;
                        this.cities = res.data.cityData;
                        this.loan_tiers = res.data.loanTierData;

                        this.$Progress.finish();
                    }else{
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'Error to load form data'
                        });
                    }
            }).then(res =>{
                $(this.$el).find('.selectpicker').selectpicker('refresh');
            })
            .catch(err => {
                console.log(err);
                this.$Progress.fail();
                swal.fire({
                    type: 'error',
                    title: 'Error to load form data'
                });
            });
        }
    }

</script>
